import { Reveal, Eyebrow } from "@/components/Reveal";

export const BeliefShiftSection = () => (
  <section data-testid="belief-shift-section" className="mx-auto max-w-4xl px-5 py-24 text-center sm:py-32">
    <Reveal>
      <Eyebrow>WHAT IF THE PROBLEM WAS NEVER YOU?</Eyebrow>
      <h2 className="mt-6 text-3xl font-extrabold leading-[1.08] tracking-tight sm:text-5xl">
        WHAT IF YOU’RE NOT BAD
        <br />
        AT FOLLOWING THROUGH?
      </h2>
      <p className="mt-6 font-serif text-2xl italic leading-snug text-lime sm:text-4xl">
        WHAT IF YOUR VISION
        <br />
        JUST ISN’T ALIVE ENOUGH
        <br />
        TO PULL YOU FORWARD?
      </p>
    </Reveal>

    <Reveal className="mx-auto mt-10 max-w-xl space-y-4 text-base text-cream/70 sm:text-lg" delay={0.1}>
      <p>You don’t need another system designed to make you more productive.</p>
      <p className="text-cream">
        You need a vision you actually desire enough to organize your life around. And the daily capacity
        to hold it.
      </p>
    </Reveal>

    <Reveal className="mt-16" delay={0.15}>
      <p className="text-3xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
        YOUR VISION DOESN’T
        <br />
        NEED MORE HUSTLE.
      </p>
      <p className="mt-3 font-serif text-3xl italic text-lime sm:text-5xl lg:text-6xl">IT NEEDS MORE OF YOU.</p>
    </Reveal>
  </section>
);
